module.exports = __webpack_public_path__ + "img/密码器8.4141b18b.jpg";